// In-store Segment sources. On the storefront /account page this key is never
// used: the storefront initialises Segment first with its website key, and
// @susu/analytics-client keeps the first initialisation.
export const SEGMENT_WRITE_KEY = {
  tst: 'TgLtItymcgnTvGzXl9bBGp5LuCqXD2fS',
  acc: '80tFeQG3E8EcPRmB6m1gjHkjaWW6NVRq',
  prd: 'uD76SgKOZpDHLj49u7kQnZgDHj1LUK05',
} as const
